/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Usage_TitleInputs */

const en_settings_usage_title = /** @type {(inputs: Settings_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan & usage`)
};

const id_settings_usage_title = /** @type {(inputs: Settings_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket & penggunaan`)
};

/**
* | output |
* | --- |
* | "Plan & usage" |
*
* @param {Settings_Usage_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_usage_title = /** @type {((inputs?: Settings_Usage_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Usage_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_usage_title(inputs)
	return en_settings_usage_title(inputs)
});